/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-13 18:37:45
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseStringToArray } from '../utils';
import classnames from 'classnames';
import { drop, head } from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = `
新闻+自媒体\t #DC333F
kol\t #FFC000
`;

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('15').then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;

    return {
      dataset,
      ...Form.parseTable(dataset),
      ...Form.parseChart(dataset),
    }
  }

  static parseTable = (dataset) => {
    const KEY = 'KEY_';
    const columns = [];
    let result = [];

    dataset.forEach(([id, ...ele], i) => {
      ele.forEach((val, ii) => {
        if (ii === 0) {
          columns.push({
            dataIndex: `${KEY}${i}`,
            title: val,
          });
        } else {
          if (!result[ii]) {
            result[ii] = {};
          }
          result[ii][`${KEY}${i}`] = val
        }
      })
    })
    result = result.filter(Boolean);

    const res = [{}, {}];
    columns.forEach(({ dataIndex }, i) => {
      if (i === 0) {
        res[0][dataIndex] = result[0][dataIndex];
        res[1][dataIndex] = result[1][dataIndex];
        return
      }
      const kol = parseFloat(result[0][dataIndex]);
      const news = parseFloat(result[1][dataIndex]);
      const count = kol + news;

      res[0][dataIndex] = count;
      res[1][dataIndex] = `${Math.round(kol / count * 10000)/100}%`
    });
    return {
      tableColumns: columns,
      tableList: res,
    }
  }

  static parseChart = (arr) => {
    const xAxis = drop(head(arr), 2);
    const data = drop(arr, 1);

    const result = [];

    data.forEach((item, index) => {
      item.forEach((ele, i) => {
        if (i === 0) {
          result[index] = { name: '', id: ele, list: [] } 
        } else if (i === 1) {
          result[index].name = ele
        } else {
          result[index].list.push(ele)
        }
      })
    })

    return {
      chartTitle: xAxis,
      chartList: result
    };
  }

  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);

    return { chartColorList: chartColorList.map(item => item[1]) }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);

    this.setState({
      colorValue: value,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P15/Form.js